import * as z from "zod";
var PrismicRepositoryRole;
(function(PrismicRepositoryRole2) {
  PrismicRepositoryRole2["SuperUser"] = "SuperUser";
  PrismicRepositoryRole2["Administrator"] = "Administrator";
  PrismicRepositoryRole2["Owner"] = "Owner";
  PrismicRepositoryRole2["Manager"] = "Manager";
  PrismicRepositoryRole2["Publisher"] = "Publisher";
  PrismicRepositoryRole2["Writer"] = "Writer";
  PrismicRepositoryRole2["Readonly"] = "Readonly";
})(PrismicRepositoryRole || (PrismicRepositoryRole = {}));
const PrismicRepositorySchema = z.object({
  domain: z.string(),
  name: z.string(),
  role: z.union([
    z.enum(PrismicRepositoryRole),
    z.record(z.string(), z.enum(PrismicRepositoryRole))
  ])
});
export {
  PrismicRepositoryRole,
  PrismicRepositorySchema
};
//# sourceMappingURL=types.js.map
